import { Box, List, Typography } from '@mui/material';
import EmptyMessage from 'core/components/EmptyMessage';
import { isEmpty } from 'lodash';
import EventCard from '../EventCard';
import { createEventProps } from '../utils';
import { MonthDaysList } from './MonthDayList/MonthDaysList';
import type { ViewComponentProps } from './types';
import type { FC } from 'react';

const MonthlyListViewCards: FC<ViewComponentProps> = (props) => {
  const { groupedByMonthAndDay, selectedDay, handleDayClick } = props;

  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <Box
        sx={{ width: 'fit-content', minWidth: 'fit-content', overflow: 'auto' }}
        borderRight={1}
        borderColor='divider'>
        <MonthDaysList
          groupedByMonthAndDay={groupedByMonthAndDay}
          selectedDay={selectedDay}
          handleDayClick={handleDayClick}
        />
      </Box>

      <Box sx={{ flexGrow: 1, overflow: 'auto', p: 2 }}>
        {selectedDay ? (
          <>
            {isEmpty(selectedDay.events) && <EmptyMessage message='События не найдены' />}

            <List
              disablePadding
              sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
              {selectedDay.events.map((event) => (
                <EventCard key={event.id} event={createEventProps(event)} />
              ))}
            </List>
          </>
        ) : (
          <Typography
            variant='body1'
            color='text.secondary'
            sx={{ textAlign: 'center', mt: 4 }}>
            Выберите день для просмотра событий
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default MonthlyListViewCards;
